// Test IDs for the Herne Tilaukset app (orders dashboard).
export const APP = {
        logout: 'app-logout-button',
        navDashboard: 'nav-dashboard-link',
        navOrders: 'nav-orders-link',
        navCustomers: 'nav-customers-link',
        navRoutes: 'nav-routes-link',
        navPrices: 'nav-prices-link',
        navInvoicing: 'nav-invoicing-link',
        navHarvest: 'nav-harvest-link',
        navUsers: 'nav-users-link',
};

export const DASHBOARD = {
        page: 'dashboard-page',
        kpiOrders: 'dashboard-kpi-orders',
        kpiStock: 'dashboard-kpi-stock',
        kpiSaldo: 'dashboard-kpi-saldo',
        kpiOrderCount: 'dashboard-kpi-order-count',
        weekChart: 'dashboard-week-chart',
        topCustomers: 'dashboard-top-customers',
        routesToday: 'dashboard-routes-today',
        openTodayBtn: 'dashboard-open-today-btn',
        openLaskutusBtn: 'dashboard-open-laskutus-btn',
        topCustomerRowPrefix: 'dashboard-top-row-',
        weekBarPrefix: 'dashboard-week-bar-',
        routeRowPrefix: 'dashboard-route-row-',
};

export const ROUTES = {
        addButton: 'routes-add-button',
        rowPrefix: 'routes-row-',
        editPrefix: 'routes-edit-',
        deletePrefix: 'routes-delete-',
        dialogName: 'routes-dialog-name',
        dialogPrintGroup: 'routes-dialog-printgroup',
        dialogSort: 'routes-dialog-sort',
        dialogActive: 'routes-dialog-active',
        dialogSave: 'routes-dialog-save',
};

export const PRICES = {
        groupCardPrefix: 'prices-group-',
        addButtonPrefix: 'prices-add-button-',
        dialogDate: 'prices-dialog-date',
        dialogPrice: 'prices-dialog-price',
        dialogSave: 'prices-dialog-save',
        historyRowPrefix: 'prices-row-',
        deletePrefix: 'prices-delete-',
};

export const INV = {
        dateFrom: 'inv-date-from',
        dateTo: 'inv-date-to',
        reloadButton: 'inv-reload-button',
        tabBillable: 'inv-tab-billable',
        tabInvoices: 'inv-tab-invoices',
        billableRowPrefix: 'inv-billable-row-',
        billableSelectPrefix: 'inv-billable-select-',
        billableSelectAll: 'inv-billable-select-all',
        generateButton: 'inv-generate-button',
        invoiceRowPrefix: 'inv-invoice-row-',
        invoiceXmlPrefix: 'inv-invoice-xml-',
        invoicePreviewPrefix: 'inv-invoice-preview-',
        invoiceDeletePrefix: 'inv-invoice-delete-',
        exportZipButton: 'inv-export-zip-button',
};

export const DAY = {
        tabPrefix: 'day-tab-', // + YYYY-MM-DD
        prev: 'day-prev-button',
        next: 'day-next-button',
        calendarTrigger: 'day-calendar-trigger',
        addRowButton: 'day-add-row-button',
        customerSelect: 'day-add-customer-select',
};

export const GRID = {
        rowPrefix: 'order-row-', // + customer_id
        maaraInputPrefix: 'order-maara-input-',
        statusSelectPrefix: 'order-status-select-',
        lahetePrefix: 'order-lahete-input-',
        ostotilausPrefix: 'order-ostotilaus-input-',
        reittiSelectPrefix: 'order-reitti-select-',
};

export const PDF = {
        dropzone: 'pdf-upload-dropzone',
        fileInput: 'pdf-upload-file-input',
        uploadButton: 'pdf-upload-submit-button',
        resultsList: 'pdf-upload-results-list',
};

export const LAHDE = {
        varastossa: 'lahde-varastossa-input',
        noukittu: 'lahde-noukittu-input',
        tilaukset: 'lahde-tilaukset-value',
        saldo: 'lahde-saldo-value',
};

export const AUDIT = {
        openPrefix: 'order-audit-open-',
        listPrefix: 'order-audit-list-',
};

export const USERS = {
        addButton: 'users-add-button',
        saveButton: 'users-save-button',
        rowPrefix: 'user-row-',
        editPrefix: 'user-edit-button-',
        deletePrefix: 'user-delete-button-',
        dialogUsernameInput: 'user-dialog-username-input',
        dialogEmailInput: 'user-dialog-email-input', // legacy back-compat
        dialogNameInput: 'user-dialog-name-input',
        dialogPasswordInput: 'user-dialog-password-input',
        dialogRoleSelect: 'user-dialog-role-select',
        dialogAliasesInput: 'user-dialog-aliases-input',
};

export const PRESENCE = {
        list: 'presence-list',
};

export const SUMMARY = {
        totalKg: 'summary-total-kg',
        ryhmaList: 'summary-ryhma-list',
        reittiList: 'summary-reitti-list',
        lahdeList: 'summary-lahde-list',
        openTodayButton: 'summary-open-today-button',
        pendingBadge: 'summary-pending-badge',
};

export const CUSTOMERS = {
        addButton: 'customers-add-button',
        saveButton: 'customers-save-button',
        rowPrefix: 'customer-row-',
        activeTogglePrefix: 'customer-active-toggle-',
        deletePrefix: 'customer-delete-button-',
        editPrefix: 'customer-edit-button-',
        dialogNroInput: 'customer-dialog-nro-input',
        dialogRyhmaSelect: 'customer-dialog-ryhma-select',
        dialogKetjuSelect: 'customer-dialog-ketju-select',
        dialogAsiakasInput: 'customer-dialog-asiakas-input',
        dialogReittiSelect: 'customer-dialog-reitti-select',
        dialogAliasesInput: 'customer-dialog-aliases-input',
        dialogPriceGroupSelect: 'customer-dialog-pricegroup-select',
        dialogShowPriceSwitch: 'customer-dialog-showprice-switch',
        openSettingsButton: 'customers-open-settings-button',
        settingsPriceKaupat: 'settings-price-kaupat-input',
        settingsPriceTukku: 'settings-price-tukku-input',
        settingsVatRate: 'settings-vat-rate-input',
        settingsSave: 'settings-save-button',
};

export const LAHETE = {
        rowPrintPrefix: 'lahete-row-print-',
        rowSelectPrefix: 'lahete-row-select-',
        selectAllVisible: 'lahete-select-all-visible',
        routeSelect: 'lahete-route-select',
        routePrintButton: 'lahete-route-print-button',
        printSelectedButton: 'lahete-print-selected-button',
        clearSelectionButton: 'lahete-clear-selection-button',
};
